import { useEffect, useState } from "react"

import { loadFogPreview, subscribeFogPreview } from "src/utils/fogPreview"

const useFogPreview = () => {
  const [enabled, setEnabled] = useState(loadFogPreview)
  useEffect(() => subscribeFogPreview(setEnabled), [])
  return enabled
}

export default useFogPreview
